// src/pages/Private/Teacher/TeacherSettings.js
import { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import axios from '../../../utils/axios';
import './TeacherSettings.css';

function TeacherSettings() {
  const { user, updateUser } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || '',
    phone: user?.phone || '',
    branch: user?.branch || '',
    experience: user?.experience || '',
    bio: user?.bio || ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await axios.put('/auth/profile', formData);
      updateUser(response.data.user);
      setMessage('Profile updated successfully');
    } catch (error) {
      setMessage('Error: ' + (error.response?.data?.msg || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="teacher-settings">
      <h1>Profile Settings</h1>
      
      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-group">
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={user?.email || ''}
            disabled
            className="disabled"
          />
        </div>

        <div className="form-group">
          <label>Phone</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Branch/Specialty</label>
          <input
            type="text"
            name="branch"
            value={formData.branch}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Experience (years)</label>
          <input
            type="text"
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            placeholder="e.g., 5 years"
          />
        </div>

        <div className="form-group">
          <label>Biography</label>
          <textarea
            name="bio"
            value={formData.bio}
            onChange={handleChange}
            rows="4"
          />
        </div>

        {message && <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>{message}</div>}

        <button type="submit" disabled={loading} className="save-btn">
          {loading ? 'Saving...' : 'Save Changes'}
        </button>
      </form>
    </div>
  );
}

export default TeacherSettings;